<template>
    <div class="report-container"
    :style="{
        'background':`linear-gradient(180deg, ${colors[colors.theme].from} 0%,  ${colors[colors.theme].to} 100%)`
    }">
        <Header></Header>
        <slide-content :routesParams="routesParams">
            <router-view :reportData="reportData"></router-view>
        </slide-content>
        <!-- <Alert v-if="alert.show"
				:imageSrc="alert.imageSrc"
				:title="alert.title"
				:subtitle="alert.subtitle"></Alert>         -->
    </div>
</template>
<script>
import SlideContent from '../components/PageSlider/SlideContent.vue' 
import Bus from '../main'
import Alert from "../components/Alerts/AlertGlobal"
import Header from "../components/Sections/HeaderDefault.vue"
export default {
    components : {
        SlideContent, Alert, Header
    },
    data(){
        return{
            routesParams : [
                {
                    title : 'Gráfico',
                    path : '/report/graphic'
                },
                {
                    title : 'Competências',
                    path : '/report/skills'
                },
                {
                    title : 'Feedback',
                    path : '/feedback-alert'
                }
            ],
            currentRoute : "feedback-alert",
            reportData : [],
            alert: {
                imageSrc: "warning",
                title: this.$t("containers.ReportContainer.alert.title"),
                subtitle: this.$t("containers.ReportContainer.alert.subtitle")
            }               
        }
    },
    async created(){
        this.colors = JSON.parse(localStorage.getItem("colors"));
        const alert = this.alert
        Bus.$on('closeAlertGlobal', this.closeAlertGlobal)
        Bus.$on('goFeedback', this.goFeedback)
        const hasReport = JSON.parse(localStorage.getItem('hasReport'))
        const gupyService = JSON.parse(localStorage.getItem("gupyServiceInfo"))
        if(hasReport || gupyService) this.routesParams.pop()
        if(gupyService){
            function warningEvent(alert){ Bus.$emit("openAlertGlobal", alert) }
            document.onmouseleave = function() { warningEvent(alert) };
            window.addEventListener("blur", function(){ warningEvent(alert)} )                  
            this.routesParams.push({title: "Gupy Redirect", path: gupyService.callback_url})
        }
        // console.log("routesParams: ", this.routesParams)
        const { reportPlayStyle } = await this.$store.getters.getSimple(['reportPlayStyle'])
        this.reportData = reportPlayStyle
    },
    destroyed(){
        Bus.$off('goFeedback')
        Bus.$off('openAlertGlobal')
    },
    methods: {
        async goFeedback(){
            await this.$router.push('/feedback-experience')
            this.showInfo = false
        },
		closeAlertGlobal(){
			this.alert.show = false
		},        
    },
    beforeRouteEnter (to, from, next) {
        next(vm => {
            vm.currentRoute = to.params.id
            Bus.$emit('updateCurrent', to.path)
        })
    },
    beforeRouteUpdate(to, from, next){
        let name = to.params.id
        this.currentRoute = name
        next()
    }
}
</script>
<style lang="scss" scoped>
    .report-container{
        height: 100vh;
        // background-color: #d9fcfa;

        .competences{
            height: 100%;
        }

        .chart-radar{

            padding-top: 5%; 
        }
        .performance{
            height: 100%;
            display: flex;
            justify-content: flex-end;
            align-items: center;
            flex-direction: column;

            .chart-media{
                margin-bottom: 90px;
            }

            .global-media{
                height: 20%;
                display: flex;
                flex-direction: column;
                align-items: center;
                color: #84989a;
                font-weight: bold;
                text-transform: uppercase;
                letter-spacing: 2px;

                .title{
                    font-size: 10px;
                }

                .media{
                    font-size: 40px;
                    position: relative;
                    width: 50px;

                    .percent{
                        font-size: 13px;
                        position: absolute;
                        top: 5px;
                        right: -15px;
                    }
                }
            }

            .footer{
                height: 15%;
                width: 100%;
                font-size: 12px;
                text-align: center;
                display: flex;
                align-items: center;
                background-color: #a3f8f6;

                .text-footer{
                    width: 90%;
                    margin: 0 auto;
                    color: #424c4d;
                }
            }
        }
    }

    @media only screen and (min-width : 750px){
        .report-container{
            height: 100%;
        }
    }
</style>
